<template>
    <div>
        <b-modal id="modal-help" ref="modal-help"
                 :title="modalTexts.title"
                 :ok-title="modalTexts.buttonIndex"
                 :cancel-title="modalTexts.buttonClose"
                 @ok="showIndex"
                 header-bg-variant='secondary'
                 header-text-variant="white"
                 size="lg" button-size="sm"
        >
            <div>
                <b-embed
                    type="iframe"
                    aspect="16by9"
                    :src="topicSource"
                    allowfullscreen
                ></b-embed>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: "HelpModal",
    /** The component's data */
    data() {
        return {
            topic: null,
            docPath: '/docs/DataDefinitions.html',
            modalTexts: {
                title: 'Guidelines & Definitions',
                buttonIndex: 'Show Index',
                buttonClose: 'Close',
            }
        }
    },
    computed: {
        topicSource: function () {
            return this.docPath+'#'+this.helpTopic;
        },
        helpTopic: function () {
            let divertToIndex = ['#recno#', '#header#'];
            let topic = this.$root.$data.HELP_TOPIC;
            if (!topic) {
                return 'index';
            }
            if (divertToIndex.includes(topic)) {
                return 'index';
            }
            return topic;
        },
    },
    methods: {
        showIndex: function (bvModalEvt) {
            bvModalEvt.preventDefault()
            if (this.$root.$data.HELP_TOPIC === 'index') {
                this.$root.$data.HELP_TOPIC ='index2';
            } else {
                this.$root.$data.HELP_TOPIC ='index';
            }
        },
    }
}
</script>

<style scoped>

</style>
